document.dispatchEvent(new CustomEvent("swym:collections-loaded"));


window.onload = function() {
  // enable/diable scroll
  // left: 37, up: 38, right: 39, down: 40,
  // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  var keys = {37: 1, 38: 1, 39: 1, 40: 1};


  function preventDefault(e) {

    //exceprions
    if ($(window).width() < 1010) {
    if ($('.customer-gallery-popup__inner').has(e.target).length > 0) {
      return;
    }
    }

    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
      get: function () { supportsPassive = true; } 
    }));
  } catch(e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  // var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

  // call this to Disable
  const disableScroll = () => {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener('wheel', preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
    document.body.classList.add("disabled");
  }

  // call this to Enable
  const enableScroll = () => {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener('wheel', preventDefault, wheelOpt); 
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
    document.body.classList.remove("disabled");
  }

  function header(){
    const header = $('#SiteHeader')
    const wWidth = $(window).width()
    const wHeight = $(window).height() -200;

    var lastScrollTop = 0;

    $(window).scroll(function(event){
      var st = $(this).scrollTop();


        if (st > 100 && wWidth < 780){

          $('.bespoke-search-form-header').hide()  
          $('.site-header__search-form-wrap').show()
        }else{
          $('.bespoke-search-form-header').show() 
          $('.site-header__search-form-wrap').show()
        }

        if (st > wHeight ) {
          $('.site-header').addClass('transition')
        }else{
          $('.site-header').removeClass('transition')
        }
  
        if (st > lastScrollTop  ){
          header.removeClass('site-header--opening')
 
         
        } 
        else if(st > wHeight){     
            header.addClass('site-header--opening')  
      
        }

        if(st < wHeight && wWidth > 700){
          header.removeClass('site-header--opening')
        }
        lastScrollTop = st;
      })  
  }

  $('.rte li').each(function(){

    $( this ).wrapInner(function() {
      return "<span style='margin-left: 15px; display: block'" + this.nodeValue + "'></span>";
    });    
  })

  function initCollectionList(){
    const scrollContainer = $('.collection-list__inner')
    const scrollBarWidth = $('.collection-list__scroll-bar').width()
    const scrollBar = $('.collection-list__scroll-bar')
    const items = $('.collection-list__item a')

    if(!scrollContainer.length){
      return;
    }
    var maxScrollLeft = scrollContainer.get(0).scrollWidth - scrollContainer.get(0).clientWidth



    if(!maxScrollLeft){
      scrollBar.css('background-color', 'transparent')

      scrollBar.find('.collection-list__scroll-thumb').hide()
    }

    const thumb = $('.collection-list__scroll-thumb')

    scrollContainer.scroll(function(e) {
      x = $('.collection-list__inner').scrollLeft() / maxScrollLeft * 100 
      thumb.css("left", `calc(${x}% - 100px)`)
    })
  }



  function initProductPage() {
    if ($('*[data-default-text]').text() === 'PRE-ORDER') {
      $('.store-availability').hide();
    }

    setTimeout(function() {
      if ($('.product-reviews button').is(':visible')) {
        $('.product-reviews button').click();
      }
    }, 2000);

    const numOfInputs = $('.variant-input input');
    const activeInput = $('.variant-input input:checked');

    if (numOfInputs.length > 0) {
      let inactiveInput = $(".variant-input input:not(:checked)").first();
      $(inactiveInput).prop('checked', true).trigger('change');
      $(activeInput).prop('checked', true).trigger('change');
      $('.sales-point').show();
    } else {
      $('.sales-point').show();
    }

    let el = $('[data-product-inventory]').get(0); // Use jQuery to select and convert to JS element
    let threshold = parseInt($('[data-product-inventory]').attr('data-threshold')) || 0;
    //let inventry = parseInt($('.js-variant-inventory-data').attr('data-quantity')) || 0;
    let inventry = parseInt($('#varId').val());
    let limited_low_threshold = parseInt($('#lowInventory').attr("data-threshold"));
    let policy = $('.js-variant-inventory-data').attr('data-policy');
console.log(inventry);
    if (!el) {
      console.warn("Element with [data-product-inventory] not found");
      return;
    }

    if (policy === "continue") {
      if($('#lowInventory').length != 0 && inventry < limited_low_threshold && inventry > 0 ){
        if (el.parentNode) {
          el.parentNode.classList.add('inventory--low');
        }
          const defaultMsg1 = 'In Stock - See Lead Times below';
          $(el).text(defaultMsg1);
          $('#preorder').val(defaultMsg1);
      }else{
        if (inventry <= threshold) {
          if (el.parentNode) {
            el.parentNode.classList.add('inventory--low');
          }
          const preorderMsg = $('.js-preorder-message').html();
  
          if ($('.js-preorder-message').attr('data-message-here')) {
            $(el).html(preorderMsg);
            $('#preorder').val(preorderMsg);
          } else {
            const defaultMsg = 'Though we aim to hold stock, our stock moves quickly. We will inform you if a delay is expected once your order is placed. Feel free to call if on a tight deadline.';
            $(el).text(defaultMsg);
            $('#preorder').val(defaultMsg);
          }
        }
        
      }
    } else {
      const preorderMsg = $('.js-preorder-message').text();

      if ($('[data-add-to-cart]').is(":disabled")) {
        $('.sales-point').hide();
        return;
      }

      if ($('.js-preorder-message').attr('data-message-here')) {
        if (el.parentNode) {
          el.parentNode.classList.add('inventory--low');
        }
        $(el).text(preorderMsg);
        $('#preorder').val(preorderMsg);
      }
      if (inventry > threshold) {
        if (el.parentNode) {
          el.parentNode.classList.remove('inventory--low');
        }
          const defaultMsg1 = 'In stock';
          $(el).text(defaultMsg1);
          $('#preorder').val(defaultMsg1);
      }
      if($('#lowInventory').length != 0 && inventry < limited_low_threshold && inventry > 0 ){
        if (el.parentNode) {
          el.parentNode.classList.add('inventory--low');
        }
          const defaultMsg1 = 'In Stock - See Lead Times below';
          $(el).text(defaultMsg1);
          $('#preorder').val(defaultMsg1);
      }
    }
  }


  function initCustomerGallery(){
    const container = document.querySelector('.customer-gallery__grid');
    const gridItems =  $('.customer-gallery__grid-item')
    const openBtn = $('.customer-gallery__grid-item .btn')
    const closeBtn = $('.icon-close-popup')
    const popups = $('.customer-gallery-popup')
    const previous = $('.customer-gallery-popup__left-btn')
    const next = $('.customer-gallery-popup__right-btn')
    let maxNum = $('.customer-gallery-popup').last().attr('data-index') 
    const filterBtns = $('.customer-gallery-filter li')


    if (!gridItems.length) {
      return;
    }

    if ($(window).width() < 1010) {
      var msnry = new Masonry( container, {
        columnWidth: '.customer-gallery__grid-item',
        itemSelector: '.customer-gallery__grid-item',
        gutter: 10
      });    
    }
    else {
      var msnry = new Masonry( container, {
        columnWidth: '.customer-gallery__grid-item',
        itemSelector: '.customer-gallery__grid-item',
        gutter: 0
      });    
    }    

    filterBtns.on('click', function(){
      let thisCategory = $(this).attr('data-category')
      $(filterBtns).removeClass('active')
      $(this).addClass('active')

      if (thisCategory == "All") {
        gridItems.each(function(){
          $(this).show()
          $(this).addClass('customer-gallery__grid-item')
        })        
      }else{
        gridItems.each(function(){
          let gridItemId = $(this).attr('data-category')
  
          if (gridItemId == thisCategory) {
            $(this).show()
            $(this).addClass('customer-gallery__grid-item')
          
          }else{
            $(this).hide()
            $(this).removeClass('customer-gallery__grid-item')
        
          }
        }) 
      }     

      msnry.reloadItems()

      msnry.layout() 
    })

    next.on('click', function(){
      let thisId = parseInt($(this).parent().parent().attr('data-index'))
      $(this).parent().parent().removeClass('active')

      popups.each(function(){
        let popupDataId = parseInt($(this).attr('data-index'))

        if (popupDataId == thisId + 1) {
          $(this).addClass('active')
          removeNextBtns(this, popupDataId)
        }
      })
    })

    previous.on('click', function(){
      let thisId = parseInt($(this).parent().parent().attr('data-index'))
      $(this).parent().parent().removeClass('active')

      popups.each(function(){
        let popupDataId = parseInt($(this).attr('data-index'))

        if (popupDataId == thisId - 1) {
          $(this).addClass('active')
          removeNextBtns(this, popupDataId)
        }
      })
    })

    closeBtn.on('click', function(){
      $(this).parent().parent().parent().removeClass('active')
      enableScroll()
    })

    openBtn.on('click', function(){

      let dataId = $(this).parent().attr('data-index')   

      popups.each(function(){
        let popupDataId = $(this).attr('data-index')

        if (popupDataId === dataId) {
          $(this).addClass('active')
          disableScroll()
          removeNextBtns(this, popupDataId)
        }
      })
    })

    gridItems.on('click', function(){

      let dataId = $(this).attr('data-index')   

      popups.each(function(){
        let popupDataId = $(this).attr('data-index')

        if (popupDataId === dataId) {
          $(this).addClass('active')
          disableScroll()
          removeNextBtns(this, popupDataId)
        }
      })
    })

    function removeNextBtns(that, popupDataId){
      if(popupDataId >= maxNum){
        $(that).find('.customer-gallery-popup__right-btn').hide()
      }

      if(popupDataId == "1"){
        $(that).find('.customer-gallery-popup__left-btn').hide()
      }
    }
  }

  function wishlist(){
    if($('.template-product').length){

      // $('.js-first-accordian').click()

      const checkForAffirm = window.setInterval(function(){
        checkIfAffirm()
      }, 50);
      
  
      function checkIfAffirm() {
        let learnMore = $(".swym-wishlist-cta") 
  
        if (learnMore.length) {
          clearInterval(checkForAffirm)  



          $('.swym-wishlist-cta').on('click', function(){
 
            setTimeout(function(){
              let learnMore = $(".swym-wishlist-cta")
              learnMore.append(
                `<span>   
                <svg class="herat-icon" style="height: 15px;width: 17px;  position: absolute; top: 3px;    left: auto; right: -31px" width="21px" height="20px" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.49923 16.1969L8.71697 17.1719C9.18196 17.5449 9.84571 17.5377 10.3025 17.1546L9.49923 16.1969ZM8.24923 4.99903C8.24869 5.68939 8.80791 6.24947 9.49826 6.25C10.1886 6.25053 10.7487 5.69132 10.7492 5.00097L8.24923 4.99903ZM14.5 2.19707L14.0758 3.37289L14.5 2.19707ZM10.2815 15.2219C8.41938 13.7279 6.61658 11.9454 5.29215 10.2453C4.62989 9.39512 4.10573 8.58912 3.7521 7.87004C3.39073 7.13524 3.24999 6.57672 3.25 6.1969L0.75 6.19687C0.749987 7.11676 1.06546 8.07202 1.50871 8.97332C1.9597 9.89035 2.58857 10.8428 3.31994 11.7816C4.78276 13.6594 6.72958 15.5773 8.71697 17.1719L10.2815 15.2219ZM3.25 6.1969C3.25003 4.3087 4.66777 3.44683 5.49924 3.44683V0.946834C3.32917 0.946834 0.750047 2.88624 0.75 6.19687L3.25 6.1969ZM5.49924 3.44683C6.17406 3.44683 6.72038 3.51702 7.18887 3.70032C7.63575 3.87516 8.07389 4.17706 8.49698 4.74596L10.503 3.25404C9.81119 2.3238 8.99933 1.72412 8.09975 1.37217C7.22178 1.02866 6.32517 0.946834 5.49924 0.946834V3.44683ZM8.25 3.99903L8.24923 4.99903L10.7492 5.00097L10.75 4.00097L8.25 3.99903ZM10.3836 4.88418C11.1026 4.16565 11.723 3.67268 12.317 3.41578C12.8575 3.18205 13.4032 3.13023 14.0758 3.37289L14.9242 1.02124C13.6184 0.550156 12.4144 0.649922 11.3247 1.12115C10.2886 1.56922 9.39817 2.3346 8.61642 3.11582L10.3836 4.88418ZM14.0758 3.37289C14.8526 3.65311 15.3293 4.08614 15.594 4.60526C15.8656 5.13794 15.9844 5.90149 15.7743 6.95214L18.2257 7.44243C18.5156 5.99302 18.4112 4.6269 17.8212 3.4697C17.2243 2.29895 16.2011 1.48189 14.9242 1.02124L14.0758 3.37289ZM15.7743 6.95214C15.5927 7.85978 14.8203 9.13752 13.4827 10.6701C12.1831 12.1591 10.4865 13.7374 8.69597 15.2391L10.3025 17.1546C12.1448 15.6095 13.9486 13.9381 15.3661 12.314C16.7457 10.7335 17.9072 9.03484 18.2257 7.44243L15.7743 6.95214Z" fill="black"/>
                </svg>
                </span>         
                `
              )
    
              $('.swym-btnlink').on('click', function(){
                setTimeout(function(){
                  checkIfAffirm();
                }, 1000);
              })
    
            }, 1000); 

          })
          
          
          setTimeout(function(){
            let learnMore = $(".swym-wishlist-cta")
            learnMore.append(
              `<span>   
              <svg class="herat-icon" style="height: 15px;width: 17px;  position: absolute; top: 3px;    left: auto; right: -31px" width="21px" height="20px" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.49923 16.1969L8.71697 17.1719C9.18196 17.5449 9.84571 17.5377 10.3025 17.1546L9.49923 16.1969ZM8.24923 4.99903C8.24869 5.68939 8.80791 6.24947 9.49826 6.25C10.1886 6.25053 10.7487 5.69132 10.7492 5.00097L8.24923 4.99903ZM14.5 2.19707L14.0758 3.37289L14.5 2.19707ZM10.2815 15.2219C8.41938 13.7279 6.61658 11.9454 5.29215 10.2453C4.62989 9.39512 4.10573 8.58912 3.7521 7.87004C3.39073 7.13524 3.24999 6.57672 3.25 6.1969L0.75 6.19687C0.749987 7.11676 1.06546 8.07202 1.50871 8.97332C1.9597 9.89035 2.58857 10.8428 3.31994 11.7816C4.78276 13.6594 6.72958 15.5773 8.71697 17.1719L10.2815 15.2219ZM3.25 6.1969C3.25003 4.3087 4.66777 3.44683 5.49924 3.44683V0.946834C3.32917 0.946834 0.750047 2.88624 0.75 6.19687L3.25 6.1969ZM5.49924 3.44683C6.17406 3.44683 6.72038 3.51702 7.18887 3.70032C7.63575 3.87516 8.07389 4.17706 8.49698 4.74596L10.503 3.25404C9.81119 2.3238 8.99933 1.72412 8.09975 1.37217C7.22178 1.02866 6.32517 0.946834 5.49924 0.946834V3.44683ZM8.25 3.99903L8.24923 4.99903L10.7492 5.00097L10.75 4.00097L8.25 3.99903ZM10.3836 4.88418C11.1026 4.16565 11.723 3.67268 12.317 3.41578C12.8575 3.18205 13.4032 3.13023 14.0758 3.37289L14.9242 1.02124C13.6184 0.550156 12.4144 0.649922 11.3247 1.12115C10.2886 1.56922 9.39817 2.3346 8.61642 3.11582L10.3836 4.88418ZM14.0758 3.37289C14.8526 3.65311 15.3293 4.08614 15.594 4.60526C15.8656 5.13794 15.9844 5.90149 15.7743 6.95214L18.2257 7.44243C18.5156 5.99302 18.4112 4.6269 17.8212 3.4697C17.2243 2.29895 16.2011 1.48189 14.9242 1.02124L14.0758 3.37289ZM15.7743 6.95214C15.5927 7.85978 14.8203 9.13752 13.4827 10.6701C12.1831 12.1591 10.4865 13.7374 8.69597 15.2391L10.3025 17.1546C12.1448 15.6095 13.9486 13.9381 15.3661 12.314C16.7457 10.7335 17.9072 9.03484 18.2257 7.44243L15.7743 6.95214Z" fill="black"/>
              </svg>
              </span>         
              `
            )
  
            $('.swym-btnlink').on('click', function(){
              setTimeout(function(){
                checkIfAffirm();
              }, 1000);
            })
  
          }, 700); 
        }
      }
    }


  }

  function initDragableSubs(){


    const slider = document.querySelector('.collection-list__inner');
      let isDown = false;
      let startX;
      let scrollLeft;

      if (!$('.collection-list__inner').length) {
        return
      }

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mousemove', (e) => {
        if(!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;

      });
  }


  function addDropCapToDescription(){
    let description = $('.drop-cap--description')

    if (!description.length) {
      return
    }
    console.log('have');
    console.log(description);


    description.wrap("<div class='drop-cap'></div>")
    let firstP = description.find('p')

    // console.log(firstP);
    // firstP.first().addClass('drop-cap')

    
  }

  initCollectionList()
  header()
  initProductPage()
  initCustomerGallery()
  wishlist()
  initDragableSubs()
  addDropCapToDescription()

 
    $(document).on("click","fieldset.variant-input-wrap .variant-input",function(ev){
      //let limited_low_threshold = parseInt($('#lowInventory').attr("data-threshold"));
        if($('#lowInventory').length != 0  && parseInt($('#varId').val()) > 0){
       //if($('#lowInventory').length != 0 && parseInt($('#varId').val()) < 10 ){
      $("li.sales-point:not(.hide) >.icon-and-text").css("opacity", "0");
      let el = $('[data-product-inventory]').get(0);
        //console.log($(this).index());
        var eqVal = $(this).index()-1;
        //console.log($(".js-product-inventory-data .js-variant-inventory-data:eq("+eqVal+")").attr("data-quantity"));
      if($(".js-product-inventory-data .js-variant-inventory-data:eq("+eqVal+")").attr("data-quantity") < parseInt($('#lowInventory').attr("data-threshold")) ){
        //console.log($(this).attr("data-quantity"));
        setTimeout(function() {
          if (el.parentNode) {
            el.parentNode.classList.add('inventory--low');
          }
            const defaultMsg1 = 'In Stock - See Lead Times below';
            $(el).text(defaultMsg1);
            $('#preorder').val(defaultMsg1);
          $("li.sales-point:not(.hide) >.icon-and-text").css("opacity", "1");
        }, 2);  
      }else{
        $("li.sales-point:not(.hide) >.icon-and-text").css("opacity", "1");
      }
        
      }
  //}
    })

  $(window).resize(function() {
    header()

  });
}
